import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../global';

class Agenda extends Component {

	htmlToText( html ) {
		let element = document.createElement( 'div' );
		element.innerHTML = html;
		return element.textContent;
	}

	getAgenda() {
		if ( this.props.meeting_materials !== false ) {
			if ( this.props.meeting_materials.data.agenda.length > 0 ) {
				return (<div>
						<span>Agenda:</span>
						<div dangerouslySetInnerHTML={ { __html: this.htmlToText( this.props.meeting_materials.data.agenda[ 0 ].post_content ) } } />
					</div>
				);
			} else {
				return (<div></div>
				);
			}
		} else {
			return (<div></div>
			);

		}

	}

	render() {
		if ( this.props.committee_participant === true ) {
			return (<div class="agenda-container">{ this.getAgenda() }</div>
			);
		} else {
			return (<div></div>
			);
		}
	}

}

function mapStateToProps( { meeting_materials, committee_participant } ) {
	return { meeting_materials, committee_participant };
}

export default connect( mapStateToProps, {} )( Agenda );